module.exports = __webpack_public_path__ + "static/media/Tile Freezone.d71c7cec.jpg";